/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { getRootPage, getPageById } from 'catalog/reducers/pages';
import { getContent } from 'catalog/reducers/contents';
import { getCatalogPlatform } from 'catalog/reducers/platforms';
import CatalogPageItem from './components/CatalogPageItem';

type Props = {
  page?: CatalogPage,
  content: CatalogPageContent,
};

const mapStateToProps = (state, { match }) => {
  const page = match.params.id
    ? getPageById(state, match.params.id)
    : getRootPage(state);

  const content = page && getContent(state, page.id, getCatalogPlatform(state));

  return {
    page,
    content: content || {},
  };
};

const Catalog = ({ page, content }: Props) => {
  if (page) {
    return <CatalogPageItem page={page} content={content} />;
  }

  return (
    <Message
      icon="clone"
      attached
      header="Aucune page dans le catalogue"
      content={"Veuillez commencer à ajouter des pages dans l'onglet Mes Pages"}
    />
  );
};

export default connect(mapStateToProps)(Catalog);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Catalog/index.js